import { SLA, SLAFormData, SLAsResponse } from '@/types/sla';
import { apiRequest } from './api';

const slaService = {
  // Obter lista de SLAs para um projeto
  async getAllByProject(
    projectId: string, 
    search?: string, 
    page?: number, 
    limit?: number
  ): Promise<[SLAsResponse | null, any]> {
    const params: any = {};
    if (search) params.search = search;
    if (page) params.page = page;
    if (limit) params.limit = limit;

    return apiRequest<SLAsResponse>({
      loaderKey: 'slas',
      method: 'get',
      url: `/app/projects/${projectId}/sla`,
      params
    });
  },

  // Obter um SLA pelo ID
  async getById(projectId: string, slaId: string): Promise<[SLA | null, any]> {
    return apiRequest<SLA>({
      loaderKey: 'sla',
      method: 'get',
      url: `/app/projects/${projectId}/sla/${slaId}`
    });
  },

  // Criar novo SLA
  async create(projectId: string, slaData: SLAFormData): Promise<[any, any]> {
    return apiRequest({
      loaderKey: 'createSla',
      method: 'post',
      url: `/app/projects/${projectId}/sla`,
      data: slaData
    });
  },

  // Atualizar SLA existente
  async update(projectId: string, slaId: string, slaData: SLAFormData): Promise<[any, any]> {
    return apiRequest({
      loaderKey: 'updateSla',
      method: 'put',
      url: `/app/projects/${projectId}/sla/${slaId}`,
      data: slaData
    });
  }
};

export default slaService; 